import { createReducer, on } from '@ngrx/store';

import {
  ServiceSummaryStatsDetails,
  SummaryStatsGroup,
} from '@ui-components/components/summary-expandable-table/summary-expandable-table.model';

import {
  loadServiceSummaryDetails,
  loadServiceSummaryDetailsFailed,
  loadServiceSummaryDetailsSuccess,
  loadServiceSummaryStats,
  loadServiceSummaryStatsFailed,
  loadServiceSummaryStatsSuccess,
} from './service.actions';

export const serviceFeatureKey = 'serviceState';

export interface State {
  serviceSummaryStats: SummaryStatsGroup[] | null;
  serviceSummaryDetails: ServiceSummaryStatsDetails | null;
  serviceSummaryLoading: boolean;
  serviceSummaryError: any;
}

export const initialState: State = {
  serviceSummaryStats: null,
  serviceSummaryDetails: null,
  serviceSummaryLoading: false,
  serviceSummaryError: null,
};

export const reducer = createReducer(
  initialState,
  on(loadServiceSummaryStats, state => ({ ...state, serviceSummaryLoading: true, serviceSummaryError: null })),
  on(loadServiceSummaryStatsSuccess, (state, { stats }) => ({
    ...state,
    serviceSummaryStats: stats,
    serviceSummaryLoading: false,
  })),
  on(loadServiceSummaryStatsFailed, (state, { error }) => ({
    ...state,
    serviceSummaryLoading: false,
    serviceSummaryError: error,
  })),
  on(loadServiceSummaryDetails, state => ({ ...state, serviceSummaryLoading: true, serviceSummaryError: null })),
  on(loadServiceSummaryDetailsSuccess, (state, { details }) => ({
    ...state,
    serviceSummaryDetails: details,
    serviceSummaryLoading: false,
  })),
  on(loadServiceSummaryDetailsFailed, (state, { error }) => ({
    ...state,
    serviceSummaryLoading: false,
    serviceSummaryError: error,
  }))
);
